import React, { useContext } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import SearchInputTrigger from '../SearchInputTrigger'
import { formatLocationsDisplayText } from 'components/Search/utils'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { LOCATION_SEARCH_INPUT_TITLE_LABEL } from 'constants/search'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

const ValueContainer = styled(BodyText)`
  margin-left: ${rem(12)};
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  line-height: ${rem(16)};
`

interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  error?: boolean;
  placeholder?: string;
  titleLabel?: string;
  className?: string;
}

function SearchLocationMobile(props: Props) {
  const {
    className,
    error,
    titleLabel = LOCATION_SEARCH_INPUT_TITLE_LABEL,
    placeholder,
    onClick,
  } = props
  const { searchItem } = useContext(GlobalSearchStateContext)

  return (
    <SearchInputTrigger
      onClick={onClick}
      error={error}
      className={className}
    >
      <ValueContainer colour="neutral-one" variant="medium" align="start" wrap="no-wrap">
        <BodyText variant="medium" weight="bold">{titleLabel}</BodyText>
        {formatLocationsDisplayText(searchItem, placeholder)}
      </ValueContainer>
    </SearchInputTrigger>
  )
}

export default SearchLocationMobile
